
import { Text, Flex, Box, HStack } from '@chakra-ui/react';
import CodeMirror from '@uiw/react-codemirror';
import { githubLight } from '@uiw/codemirror-theme-github';
import { Spinner } from '@chakra-ui/react'

function Output({
    text = 'You need to enter input first',
    placeholderResValue = 'You need to enter input first',
    isError = false,
    isDisabled = true,
    isOpenCard = false,
    setIsOpenCard = () => { },
    isLoading = false
}) {

    const openCard = () => { setIsOpenCard(!isOpenCard) }

    return (
        <> {isOpenCard
            ? <Flex ml="30px"
                h="100%"
                mb="30px"
                onClick={isDisabled ? () => { } : openCard}
                _hover={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                p={5} >
                <Box>
                    <Text fontWeight={isDisabled ? '400' : '700'} fontSize="16px" mr="40px" >
                        Result:
                    </Text>
                    {!text ?
                        null : <Box w='100%' mt="20px" fontSize='12px'>
                            <CodeMirror
                                value={text}
                                height="40vh"
                                width="90vh"
                                theme={githubLight}
                            />

                        </Box>}
                </Box>
            </Flex > :
            <HStack
                ml="30px"
                h="100%"
                mb="30px"
                onClick={isDisabled ? () => { } : openCard}
                _hover={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                p={5}
                data-testid="accordion-title">
                <HStack>
                    <Text fontWeight={isDisabled ? '400' : '700'} fontSize="16px" mr="40px">
                        Result:
                    </Text>
                    {isLoading ?
                        <Spinner />
                        : (<Text fontSize="16px" >
                            {placeholderResValue}
                        </Text>)
                    }
                </HStack>
            </HStack>}</>
    );
}

export default Output;
